import React, { createContext, useContext, useState } from 'react';

const ProcessingStateContext = createContext();
const ProcessingDispatchContext = createContext();

function ProcessingProvider({ children }) {
  const [processingState, setProcessingState] = useState({ isProcessing: false, percentage: 0 });

  return (
    <ProcessingStateContext.Provider value={processingState}>
      <ProcessingDispatchContext.Provider value={setProcessingState}>
        {children}
      </ProcessingDispatchContext.Provider>
    </ProcessingStateContext.Provider>
  );
}

function useProcessingState() {
  const context = useContext(ProcessingStateContext);
  if (context === undefined) {
    throw new Error('useProcessingState must be used within a ProcessingProvider');
  }
  return context;
}

function useProcessingDispatch() {
  const context = useContext(ProcessingDispatchContext);
  if (context === undefined) {
    throw new Error('useProcessingDispatch must be used within a ProcessingProvider');
  }
  return context;
}

export { ProcessingProvider, useProcessingState, useProcessingDispatch };
